// Actions for UI modals
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
export const SHOW_SIGNUP_MODAL = 'SHOW_SIGNUP_MODAL';
export const HIDE_SIGNUP_MODAL = 'HIDE_SIGNUP_MODAL';

export const showLoginModal = () => ({ type: SHOW_LOGIN_MODAL });
export const hideLoginModal = () => ({ type: HIDE_LOGIN_MODAL });
export const showSignupModal = () => ({ type: SHOW_SIGNUP_MODAL });
export const hideSignupModal = () => ({ type: HIDE_SIGNUP_MODAL });
